import clsx from 'clsx'
import React from 'react'

import { Loader } from '../Loader'
import { DesignLanguage, useIsDesignLanguage } from '../Theme'
import { Text, TextSizes } from '../Typography'
import { useVerifyingCountdown } from './hooks'
import styles from './styles.module.scss'

interface CountdownTimerProps {
  loaderText: string
  loaderTextExtended?: string
  loaderTimeSecondsAndMinutes: string
  loaderTimeSeconds: string
  loaderTimeExtended?: string
  time: number
  testNameSpace: string
  themeClass?: string
  t: Function
  textSize: TextSizes
}

export const CountdownTimer = ({
  loaderText,
  loaderTextExtended,
  loaderTimeSecondsAndMinutes,
  loaderTimeSeconds,
  loaderTimeExtended,
  time,
  testNameSpace,
  themeClass = '',
  t,
  textSize,
}: CountdownTimerProps): JSX.Element => {
  const { isCountingDown, minutes, seconds } = useVerifyingCountdown(time)
  const isArcadeDesign = useIsDesignLanguage(DesignLanguage.Arcade)

  const verifyingTextClass = themeClass.length > 0 ? clsx(styles.verifyingText, themeClass) : styles.verifyingText
  // for SMS verification, Loader text is static when not counting down, and loader time text disappears
  // for ID verification, Loader text and loader time text is dynamic when not counting down
  const loaderTextExtendedOrDefault = loaderTextExtended ?? loaderText

  const getCountingDownText: () => string = () => {
    let countingDownText: string = ''
    if (isCountingDown) {
      if (minutes > 0) {
        // Display time in minutes and seconds
        countingDownText = t(loaderTimeSecondsAndMinutes, { seconds, minutes })
      } else {
        // Display time in seconds only
        countingDownText = t(loaderTimeSeconds, { count: seconds })
      }
    } else {
      if (loaderTimeExtended !== undefined) {
        // Display extended loader time message
        countingDownText = t(loaderTimeExtended)
      }
    }
    return countingDownText
  }
  const countingDownText = getCountingDownText()
  const getLoaderText = (): string => {
    if (isCountingDown) {
      return t(loaderText)
    }
    return t(loaderTextExtendedOrDefault)
  }
  return (
    <>
      <Loader text={getLoaderText()} textProps={{ bold: true }} testNameSpace={testNameSpace} />
      <div className={verifyingTextClass}>
        <Text size={textSize} testNameSpace={testNameSpace} color={isArcadeDesign ? 'Subtle' : undefined}>
          {countingDownText}
        </Text>
      </div>
    </>
  )
}
